<template>
  <div class="toolbar">

    <CurvedBottomNavigation
        foreground-color='#00a5a7'
        badge-color='#FBC02D'
        background-color='#FFFFFF'
        icon-color='#0000008A'
        :options="options" v-model="selected"
    ></CurvedBottomNavigation>
  </div>
</template>
<script>
import { CurvedBottomNavigation } from "bottom-navigation-vue";
import "bottom-navigation-vue/dist/style.css";

export default {
  components: { CurvedBottomNavigation },
  name: 'footer-app',
  data: () => ({
    selected: 1,
    options: [

      {
        id: 2,
        icon: "fa-solid fa-qrcode",
        title: "اسکن بلیت",
        path: { name: "scaner" },
      },
      {
        id: 1,
        icon: "fas fa-home",
        title: "صفحه اصلی",
        path: { name: "home" },
      },
    ],
  }),
  mounted () {
    this.selectedItems;
  },
  computed: {
    selectedItems(){
      this.selected = this.selectedItem;
    }
  },
  props: [
    "selectedItem"
  ],
}
</script>
<style scoped>
.toolbar{
  width: 100%;
  height: 60px;
  background: #004815;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000000;
}
</style>